"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WoodlandInitiatives = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
class WoodlandInitiatives {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.WOODLAND_INITIATIVES;
        this.description = 'Increase oxygen 1 step. Draw 1 card for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.TRANSHUMANS;
        this.currentDelegate = PartyName_1.PartyName.POPULISTS;
    }
    resolve(game, turmoil) {
        game.increaseOxygenLevel(game.getPlayers()[0], 1);
        game.getPlayers().forEach((player) => {
            const influence = turmoil.getPlayerInfluence(player);
            if (influence > 0)
                player.drawCard(influence);
        });
    }
}
exports.WoodlandInitiatives = WoodlandInitiatives;
//# sourceMappingURL=WoodlandInitiatives.js.map